//eslint-disable-next-line
import axios, { $asyncGet, $asyncPost } from '../common.js';

/**
 * 获取所有发卷通道
 * v3/merchant/coupon/base/ListDistributionChannels
 */
export function getListDistributionChannels() {
  return $asyncGet(`v3/merchant/coupon/base/ListDistributionChannels?merchant_id=${localStorage.getItem("merchant_id")}`);
}

/**
 * 新建卷
 * v3/merchant/coupon/base/create
 * @param {*} data
 * @returns
 */
export function couponCreate(data) {
  return $asyncPost("v3/merchant/coupon/base/create", data);
}

/**
 * 修改卷
 * v3/merchant/coupon/base/update
 * @param {object} data
 * @returns
 */
export function couponUpdate(data) {
  console.log("data----------------", data);
  return $asyncPost(`v3/merchant/coupon/base/update?coupon_no=${data.coupon_no}`, data);
}

/**
 * 店铺获取所有优惠卷
 * v3/merchant/coupon/base/List
 * @param {string} start_time 开始时间
 * @param {string} expire_time 截止时间
 * @param {string} merchant_id 店铺id
 * @returns
 */
export function mchCouponList(start_time, expire_time, merchant_id = localStorage.getItem("merchant_id")) {
  return $asyncGet(`v3/merchant/coupon/base/List?start_time=${start_time}&expire_time=${expire_time}&merchant_id=${merchant_id}`)
}

/**
 * 审核优惠卷
 * @param {string} coupon_no 卷号
 * @param {string} merchant_id 店铺id
 * @returns
 */
export function couponAudit(coupon_no, merchant_id = localStorage.getItem("merchant_id")) {
  return $asyncPost(`v3/merchant/coupon/base/audit?coupon_no=${coupon_no}&merchant_id=${merchant_id}`);
}

/**
 * 停用优惠卷
 * @param {string} coupon_no 卷号
 * @param {string} merchant_id 店铺id
 * @returns
 */
export function couponStop(coupon_no, merchant_id = localStorage.getItem("merchant_id")) {
  return $asyncPost(`v3/merchant/coupon/base/stop?coupon_no=${coupon_no}&merchant_id=${merchant_id}`);
}
